import rules from "./rbac-rules";
import UserUtils from "../utils/UserUtils";

/**
 * Permet de check si un utilisateur/client(s) a les habilitations pour accéder a une page/action
 * @param {*} action 
 * @param {*} codes
 */
const check = (action, codes) => {
  let permissions = [];
  // Roles de l'utilisateur
  const userRoles = UserUtils.getRoles();

  const customersCode = codes ? codes : UserUtils.getUser().code_client;
  const customersExt = JSON.parse(localStorage.getItem("customersExt"))?.filter(c => customersCode.includes(c.code));

  // Jointure des roles clients et roles utilisateurs
  let roles = [];
  if(customersExt) {
    customersExt.forEach(c => {
      if(c.roles) {
        c.roles.forEach(r => {
          if(!roles.includes(r) && userRoles.includes(r)) {
            roles.push(r);
          }
        })
      }
    });
  }

  if (!roles) {
    return false;
  }

  roles.forEach(role => {
    if (rules[role]) {
      rules[role].forEach(rule => {
        permissions.push(rule);
      })
    }
  });

  let customersPermissions = permissions && permissions.includes(action)

  if(customersPermissions) {
    return true;
  }

  // Activitees types clients
  let typesActCustomers = [];

  if (customersCode && customersExt) {
    customersExt.filter(c => customersCode.includes(c.code)).forEach(c => {
      if(c.activities) {
        c.activities.forEach(a => {
          typesActCustomers.push(`${c.type}-${a}`)
        });
      }
    });
  }

  customersPermissions = false;
  if (typesActCustomers.length > 0) {
    const typesActivities = Object.keys(rules).filter(r => !r.startsWith('extc')).filter(r => rules[r].includes(action));
    customersPermissions = typesActCustomers.filter(a => typesActivities.includes(a)).length > 0;
  }

  return customersPermissions;
};

export default check